
import React from 'react'
import { ScaleExplanation } from '../../atoms/ScaleExplanation'
import { IIntakeStep } from './IIntakeStep'
import { IntakeStepButton } from './IntakeStepButton'
import { IntakeStepScale } from './IntakeStepScale'
import { IntakeStepRadioButtons } from './IntakeStepRadioButtons'

const lang = process.env.REACT_APP_LANGUAGE === 'es' ? 'es' : 'en'

const translations = {
  'en': {
    okLetsGo: 'OK, LET\'S GO',
    disagree: 'Disagree',
    agree: 'Agree',
    unsure:'Unsure\nDon\'t know',
    instructions: 'Please read the following statements and choose the number that reflects your beliefs.',
    painMedication: 'Pain medication',
    sideEffectsWorse: 'Side effects are something to worry about when giving children pain medication.',
    painMedsWorry: 'When giving children pain medication, one should be concerned about addiction and later abuse.',
    painMedsBest: 'When giving children pain medication, one should be concerned about addiction and later abuse.',
    painMedsChildren: 'Children feel less pain than adults.',
    childrenCry: 'Children in pain express themselves by crying or whining.',
  },
  'es': {
    okLetsGo: 'OK, Vamos',
    disagree: 'En \ndesacuerdo',
    agree: 'De \nacuerdo',
    unsure:'No estoy \nseguro/No sé',
    instructions: 'Por favor, lea las siguientes afirmaciones y elija el número que refleje sus creencias.',
    painMedication: 'Medicamento para el dolor',
    sideEffectsWorse: 'Los efectos secundarios son algo de lo que hay que preocuparse cuando se administran analgésicos a los niños.',
    painMedsWorry: 'Cuando se administran analgésicos a los niños, hay que preocuparse por la adicción y el abuso posterior.',
    painMedsBest: 'Los analgésicos funcionan mejor cuando se toman raramente y para el peor dolor.',
    painMedsChildren: 'Los niños sienten menos dolor que los adultos.',
    childrenCry: 'Los niños con dolor se expresan llorando o gimiendo.',
  },
}

export const intake3Steps: IIntakeStep[] = [
  {
    Component: IntakeStepButton, buttonLabel: translations[lang].okLetsGo, children: <div>
      <div>{translations[lang].instructions}</div>
      <ScaleExplanation labels={[ translations[lang].disagree, translations[lang].agree,  translations[lang].unsure ]} />
    </div>, completed: intake => !!intake.checkedPainMedsInfoText,
    label: translations[lang].painMedication,
    name: 'checkedPainMedsInfoText',
  },
  {
    Component: IntakeStepScale, completed: intake => intake.painMedsWorrySideEffects !== null,
    label: translations[lang].sideEffectsWorse,
    name: 'painMedsWorrySideEffects', scaleFrom: 1, scaleTo: 3,
  },
  {
    Component: IntakeStepScale, completed: intake => intake.painMedsConcernedAddictionAbuse !== null,
    label:translations[lang].painMedsWorry,
    name: 'painMedsConcernedAddictionAbuse', scaleFrom: 1, scaleTo: 3,
  },
  {
    Component: IntakeStepScale, completed: intake => intake.painMedsWorksBestRarelyWorst !== null,
    label: translations[lang].painMedsBest,
    name: 'painMedsWorksBestRarelyWorst', scaleFrom: 1, scaleTo: 3,
  },
  {
    Component: IntakeStepScale, completed: intake => intake.painMedsChildrenFeelLessPain !== null,
    label: translations[lang].painMedsChildren,
    name: 'painMedsChildrenFeelLessPain', scaleFrom: 1, scaleTo: 3,
  },
  {
    Component: IntakeStepScale, completed: intake => intake.painMedsExpressCryingWhining !== null,
    label: translations[lang].childrenCry,
    name: 'painMedsExpressCryingWhining', scaleFrom: 1, scaleTo: 3,
  },
]


// WEBPACK FOOTER //
// ./src/organisms/Intakes/intake3Steps.tsx